"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var NumberFormatter = function NumberFormatter(number, options) {
  if (typeof Number(number) !== 'number') throw new Error('Invalid number');
  var lang = document.documentElement.lang;
  return Intl.NumberFormat([lang], options).format(Number(number));
};
var _default = NumberFormatter;
exports["default"] = _default;